<template>
  <div class="container">
    <div class="mwow-detail-header">
      <div class="left">
        <div class="back-btn" @click="$router.go(-1)">
          <i class="el-icon-arrow-left"></i>
          <span>返回</span>
        </div>
      </div>
      <div class="mid">
        <p>学员转课</p>
      </div>
      <div class="right"></div>
    </div>
    <!-- 学员信息 -->
    <div style="margin: 0 60px">
      <div class="header-info block" style="margin: 14px 0 18px 0">
        <p class="title">转出信息</p>
        <div class="user">
          <span class="border">{{ studentData.name }}</span
          >{{ studentData.area_code ? "+" + studentData.area_code : "" }}
          {{ studentData.mobile }}
        </div>
      </div>
    </div>
    <div style="margin: 0 60px">
      <!-- 退课信息 -->
      <!-- <p class="tips" style="margin-bottom: 12px">
        统计退款课程已经耗课数、剩余课时数，可手动修改退课课时数，并根据单价自动计算金额。
      </p> -->
      <output-detail
        :origin-data.sync="outputDetailData"
        @change="handleOutPutChange"
      ></output-detail>
      <div class="sum-total-wrap" style="margin: 26px 30px">
        <div class="price">
          应退金额：<span class="mwow-red"
            >￥{{ outputDetailData.shouldRefund }}</span
          >
        </div>
      </div>
      <!-- 转入课信息 -->
      <input-course
        :origin-data.sync="inputCourseData"
        :origin-course-id="outputDetailData.course_id"
        @changeStudentInfo="changeStudent"
      ></input-course>
      <div class="sum-total-wrap" style="margin: 26px 30px">
        <div class="price">
          应收金额：<span class="mwow-red"
            >￥{{ inputCourseData.shouldPay }}</span
          >
        </div>
      </div>
      <!-- 转课结算 -->
      <div class="block">
        <p class="title">转课结算</p>
        <div :class="`pay-form-wrap ${priceMatchMark ? '' : 'error'}`">
          <div class="total">
            <span class="text"
              >退课金额：￥{{ outputDetailData.shouldRefund }}</span
            >
            <span class="text"
              >购课金额：￥{{ inputCourseData.shouldPay }}</span
            >
            <span class="text" v-if="orderResult < 0"
              >应收金额：￥{{ Math.abs(orderResult / 100) }}
              <span class="tag green">收</span>
            </span>
            <span class="text" v-if="orderResult > 0"
              >应退金额：￥{{ Math.abs(orderResult / 100) }}
              <span class="tag red">退</span>
            </span>
          </div>
          <div class="form mwow-form flex" v-if="orderResult <= 0">
            <span class="label">付款方式：</span>
            <template>
              <el-radio-group v-model="payTypeRadio" class="cashier-wrap">
                <el-radio
                  border
                  :label="item.key"
                  v-for="item in payType.filter((it) => {
                    if (it.key === 10 || it.key === 7) {
                    } else {
                      return it;
                    }
                  })"
                  :key="item.key"
                  size="mini"
                  :disabled="!online_pay && item.key === 999"
                  class="mwow-radio"
                  :class="{ 'disable-radio': !online_pay && item.key === 999 }"
                >
                  {{ item.value }}
                  <span
                    class="open"
                    v-if="!online_pay && item.key === 999"
                    @click="handleOpenOnlinePay"
                  >
                    立即开通
                  </span>
                </el-radio>
              </el-radio-group>
            </template>
          </div>
        </div>
        <div
          class="sum-total-wrap mwow-form"
          style="padding: 20px 3px 0 0; margin-top: 8px"
          :style="{ borderTop: orderResult < 0 ? '1px solid #d9dadb' : '' }"
        >
          <div class="select-type" v-if="orderResult <= 0">
            <el-radio-group v-model="selectTypeRadio">
              <el-radio
                border
                size="mini"
                :label="1"
                :key="1"
                class="mwow-radio"
              >
                <span>全额付款</span>
                <span class="text price-icon">
                  ￥{{ Math.abs(orderResult / 100) }}
                </span>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="price">
            实{{ orderResult > 0 ? "退" : "收" }}金额：

            <span class="mwow-green">
              ￥{{ Math.abs(orderResult / 100) }}
            </span>
          </div>
          <div class="price">
            应{{ orderResult > 0 ? "退" : "收" }}金额：<span class="mwow-red">
              ￥{{ Math.abs(orderResult / 100) }}
            </span>
          </div>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="block">
        <p class="title">基本信息</p>
        <el-form
          size="mini"
          :model="staffForm"
          ref="staffForm"
          :rules="staffRules"
          label-width="72px"
        >
          <!-- 开通线上支付，且不为乐沃收银时展示；未开通线上支付，都展示-->
          <el-form-item
            label="支付时间:"
            v-if="
              (orderResult <= 0 && payTypeRadio !== 999 && online_pay) ||
              (!online_pay && orderResult <= 0)
            "
          >
            <el-date-picker
              v-model="handle_time"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm"
              @change="changeHandle"
              :picker-options="disableOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="操作人员:">
            <div class="big-box">
              <div>{{ username }}</div>
              <div class="item">
                <span style="color: red">*&nbsp;</span>
                <span class="label"
                  >业务人员：<br />
                  <span style="color: #f56c6c" v-show="showBusinessPerson"
                    >请选择业务人员</span
                  >
                </span>
                <div class="content belong-wrap">
                  <span
                    class="tag"
                    v-for="item in staffCheckedData"
                    :key="item.staff_id"
                    >{{ item.name }}</span
                  >
                  <addStaffDialog
                    :originData="staffCheckedData"
                    @change="addStaffChange"
                  >
                    <span class="btn">添加员工</span>
                  </addStaffDialog>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="转课原因:" prop="content">
            <el-input
              v-model="staffForm.content"
              placeholder="请输入"
              maxlength="250"
              type="textarea"
              rows="3"
              style="width: 60%"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="bottom-btns">
        <div
          class="mwow-button-filled mini"
          style="margin-right: 10px"
          @click="handleBack"
        >
          取消
        </div>
        <div class="mwow-button-filled success mini" @click="checkPackageType">
          保存
        </div>
      </div>
    </div>
    <el-dialog
      title="转课确认"
      :visible.sync="confirmDialogVisible"
      @close="hideConfirmDialog"
    >
      <div class="confirm-dialog">
        <div class="transfer-out">转出信息</div>
        <div class="info-wrap">
          <p class="head">
            <span class="name">{{ studentData.name }}</span
            >{{ studentData.area_code ? "+" + studentData.area_code : "" }}
            {{ studentData.mobile }}
          </p>
          <div class="table">
            <div class="th row-7">
              <div class="td">购买课时</div>
              <div class="td">赠送课时</div>
              <div class="td">耗课数</div>
              <div class="td">剩余金额</div>
              <div class="td">转课课时</div>
              <div class="td">转课金额</div>
              <div class="td">手续费</div>
            </div>
            <div class="item">
              <p class="title">【课程】- {{ outputDetailData.product_name }}</p>
              <div class="tr row-7">
                <div class="td">
                  {{ outputDetailData.quantity }}
                </div>
                <div class="td">
                  {{ outputDetailData.give_product_quantity }}
                </div>
                <div class="td">
                  {{ outputDetailData.consume_number }}
                </div>
                <div class="td">￥{{ outputDetailData.usable_amount }}</div>
                <div class="td mwow-red">
                  {{ outputDetailData.refundNumber }}
                </div>
                <div class="td mwow-red">
                  ￥{{ outputDetailData.refundAmount / 100 }}
                </div>
                <div class="td mwow-red">
                  ￥{{ outputDetailData.handlingFee }}
                </div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">
            应退金额：<span class="red"
              >￥{{ outputDetailData.shouldRefund }}</span
            >
          </p>
          <p class="input-title">转入课程</p>
          <p class="head" v-if="transferInMe === false">
            <span class="name">[自己] {{ studentData.name }}</span
            >{{ studentData.area_code ? "+" + studentData.area_code : "" }}
            {{ studentData.mobile }}
          </p>
          <p class="head" v-else>
            <span class="name">
              [其他学员]
              {{
                JSON.stringify(transferInStudentInfo) != "{}" &&
                transferInStudentInfo.student_info.length > 0
                  ? transferInStudentInfo.student_info[0].name
                  : "-"
              }}
            </span>
            +{{
              JSON.stringify(transferInStudentInfo) != "{}" &&
              transferInStudentInfo.student_info.length > 0
                ? transferInStudentInfo.student_info[0].area_code +
                  " " +
                  transferInStudentInfo.student_info[0].mobile
                : "-"
            }}
          </p>
          <div class="table">
            <div class="th row-5">
              <div class="td">内容价格</div>
              <div class="td">转入课时</div>
              <div class="td">直减</div>
              <div class="td">课程有效期</div>
              <div class="td">小计</div>
            </div>
            <div
              class="item"
              v-for="(item, index) in inputCourseData.courseList"
              :key="index"
            >
              <p class="title">【课程】- {{ item.title }}</p>
              <div class="tr row-5">
                <div class="td">{{ item.course_spec_name }}</div>
                <div class="td">{{ item.input_quantity }}</div>
                <div class="td">￥{{ item.discount_number }}</div>
                <div class="td">{{ item.effective_time || "-" }}</div>
                <div class="td mwow-red">￥{{ item.total / 100 }}</div>
              </div>
            </div>
          </div>
          <p class="sum-wrap">
            应收金额：<span class="red">￥{{ inputCourseData.shouldPay }}</span>
          </p>
        </div>
        <div class="pay-info">
          <p>
            <span> {{ orderResult <= 0 ? "收款方式：" : "退款方式：" }}</span>
            <!-- 开通线上支付 -->
            <!-- 收入 -->
            <span v-if="payTypeRadio && orderResult <= 0">
              <span
                class="tag"
                v-for="(item, index) in payType.filter(
                  (it) => it.key === payTypeRadio
                )"
                :key="index"
              >
                {{ item.value }}
              </span>
            </span>
            <!-- 支出 -->
            <span v-else>
              <span class="tag" v-if="!refundOriginalSupport && selInputCourse">
                手动转账
              </span>
              <span class="tag" v-else> 原路退回 </span>
            </span>
          </p>
          <p v-if="orderResult < 0">
            实收金额：<span class="mwow-green"
              >￥{{ Math.abs(orderResult / 100) }} 元</span
            ><span class="type-tag green">收</span>
          </p>
          <p v-if="orderResult > 0">
            实退金额：<span class="mwow-red"
              >￥{{ Math.abs(orderResult / 100) }} 元</span
            >
            <span class="type-tag red">退</span>
          </p>
        </div>
        <div class="warning-info">
          <i class="el-icon-warning"></i
          >请仔细核对信息，避免填写错误，提交后订单则不可修改。
        </div>
        <div class="bottom-btns">
          <div class="mwow-button-filled mini" @click="hideConfirmDialog">
            取消
          </div>
          <div class="mwow-button-filled success mini" @click="confirmSubmit">
            确定
          </div>
        </div>
      </div>
    </el-dialog>
    <approve-tips-dialog
      :visible.sync="approveDialogVisible"
      :order-id="orderId"
    ></approve-tips-dialog>
    <!-- 付款码弹窗 -->
    <!-- <payment-code-dialog
      :originData="payCodeDialogData"
      :originPaymentDialogVisible="paymentDialogVisible"
      @change="paymentCodeDialogChange"
    >
    </payment-code-dialog> -->
    <!-- 扫码收款 -->
    <!-- <scan-pay-code-dialog
      :visible.sync="scanPayCodeDialogVisible"
      :order-data="scanPayCodeDialogData"
    ></scan-pay-code-dialog> -->
    <!-- 开通弹窗 -->
    <el-dialog
      title="开通乐沃收银"
      :visible.sync="openOnlinePayDialog"
      @close="openOnlinePayDialog = false"
      width="380px"
    >
      <div class="dialog">
        <p class="content">请联系总部督导或客服开通乐沃收银</p>
        <div class="flex btns">
          <div class="cat-btn" @click="openOnlinePayDialog = false">
            我知道了
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 线上扫码合并弹窗 -->
    <merge-scan-type-dialog
      v-if="mergeScanTypeDialogVisible"
      @change="handleMergeScanTypeChange"
      :originData="payCodeDialogData"
    >
    </merge-scan-type-dialog>
  </div>
</template>
<script>
import approveTipsDialog from "@/components/approveTipsDialog.vue";
import outputDetail from "./outputDetail.vue";
import inputCourse from "./inputCourse.vue";
import { solveLargeNumber } from "@/utils/common";
import { studentDetail } from "@/api/studyDetails";
import {
  getPayment,
  lessonTransferApi,
  getHuifuPaymentUrlApi,
} from "@/api/order";
import { UserModule } from "@/store/module/user";
import addStaffDialog from "@/components/addStaffDialog.vue";
// <!-- 注释：v2.56.x  -->
// import paymentCodeDialog from "@/components/paymentCodeDialog.vue";
// import scanPayCodeDialog from "@/components/scanPayCodeDialog.vue";
import mergeScanTypeDialog from "@/components/mergeScanTypeDialog.vue";

export default {
  name: "orderTransfer",
  components: {
    outputDetail,
    inputCourse,
    approveTipsDialog,
    addStaffDialog,
    // <!-- 注释：v2.56.x  -->
    // paymentCodeDialog,
    // scanPayCodeDialog,
    mergeScanTypeDialog,
  },
  data() {
    return {
      studentData: {}, // 学员信息
      outputDetailData: {
        // 转出课信息
        product_id: 0,
        shouldRefund: 0,
      },
      inputCourseData: {
        // 转入课信息
        shouldPay: 0,
        courseList: [],
      },
      payType: [], // 支付类型
      priceMatchMark: true, // 支付类型检查标识
      realReceive: 0, // 转课结算实收
      staffForm: {
        // 员工信息
        content: "",
      },
      handle_time: "", //支付时间
      staffRules: {
        content: [
          { required: true, message: "请输入转课原因", trigger: "change" },
        ],
      },
      confirmDialogVisible: false,
      approveDialogVisible: false,
      orderId: 0,
      staffCheckedData: [], // 选中业务人员
      staffLoadEnd: false,
      staffPage: 0,
      transfer_join_student_id: Number(this.$route.query.sid), // 转入学员id
      transferInStudentInfo: {}, // 转入课其他学员信息
      transferInMe: false,
      showBusinessPerson: false, // 是否选择业务人员
      payTypeRadio: 0, // 选中的支付单选
      selectTypeRadio: 1, // 选中的全额还是分期，默认选中全额付款
      paymentDialogVisible: false, // 付款码弹框
      payCodeDialogData: {},
      scanPayCodeDialogVisible: false,
      scanPayCodeDialogData: {}, // scan流程中需要的订单信息
      refundOriginalSupport: false, // 是否支持原路退回
      selInputCourse: false, // 是否选中转入信息
      online_pay: false, // 是否开通线上支付
      mergeScanTypeDialogVisible: false, // 扫码合并弹窗
      openOnlinePayDialog: false,
      cardForm: {
        bank_name: "",
        bank_card: "",
        open_bank: "",
        card_holder_name: "",
      },
      cardFormRules: {
        bank_name: [
          { required: true, message: "请填写银行名称", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 12) {
                callback(new Error("请输入2-12字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        bank_card: [
          { required: true, message: "请填写银行卡号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 13 || String(value).length > 19) {
                callback(new Error("请输入13-19字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        open_bank: [
          { required: true, message: "请填写开户行", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 24) {
                callback(new Error("请输入2-24字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        card_holder_name: [
          { required: true, message: "请填写持卡人姓名", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (String(value).length < 2 || String(value).length > 10) {
                callback(new Error("请输入2-10字"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      disableOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    orderResult() {
      // 结果= 转出总额 - 转入总额
      return (
        solveLargeNumber(this.outputDetailData.shouldRefund) -
        solveLargeNumber(this.inputCourseData.shouldPay)
      );
    },
    username() {
      return UserModule.userInfo.staff_name;
    },
  },
  watch: {
    inputCourseData: {
      handler(n, o) {
        if (n.courseList.length > 0) {
          this.selInputCourse = true;
        } else {
          this.selInputCourse = false;
        }
      },
    },
  },
  created() {
    const sid = Number(this.$route.query.sid);
    if (sid) {
      studentDetail({ student_id: sid }).then((res) => {
        this.studentData = res.data;
      });
    }
    getPayment().then((res) => {
      if (res.error_code === 0) {
        this.payType = res.data.list;
        // 首位添加乐沃收银项
        this.payType.unshift({
          key: 999,
          value: "乐沃收银",
        });
        if (this.payType.length > 0 && res.data.online_pay) {
          this.payTypeRadio = res.data.list[0].key;
        }
        // 支付方式后端已做开通或未开通判断的返回
        this.online_pay = res.data.online_pay;
        this.payType = res.data.list;
      }
    });
    this.todayTime();
  },
  methods: {
    addStaffChange(val) {
      this.staffCheckedData = val;
      if (this.staffCheckedData.length) {
        this.showBusinessPerson = false;
      } else {
        this.showBusinessPerson = true;
      }
    },
    changeStudent(v) {
      this.transferInStudentInfo = v;
      if (v.transferType === 1) {
        this.transfer_join_student_id = this.studentData.student_id;
      } else {
        if (v.student_info.length > 0) {
          this.transfer_join_student_id = v.student_info[0].student_id;
        }
      }
    },
    changeHandle(e) {
      e ? this.todayTime(e.getTime()) : ""; // 修改时间
    },
    todayTime(t) {
      if (!t) {
        const date = new Date();
        this.gethandleTime(date);
      } else {
        const date = new Date(t);
        this.gethandleTime(date);
      }
    },
    gethandleTime(date) {
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const mm = m < 10 ? "0" + m : m;
      const d = date.getDate();
      const dd = d < 10 ? "0" + d : d;
      const H = date.getHours();
      const HH = H < 10 ? "0" + H : H;
      const M = date.getMinutes();
      const MM = M < 10 ? "0" + M : M;
      const S = date.getSeconds();
      const SS = S < 10 ? "0" + S : S;
      const time = y + "-" + mm + "-" + dd + " " + HH + ":" + MM + ":" + SS;
      this.handle_time = time;
    },
    // handlePayTypeCheck(v, i) {
    //   if (v) {
    //     const payList = [...this.payType];
    //     const checked = payList.filter((item) => {
    //       return item.checked;
    //     }).length;
    //     if (checked === 1 && this.realReceive === 0) {
    //       this.payType[i].total = Math.abs(this.orderResult / 100);
    //     }
    //   } else {
    //     this.payType[i].total = 0;
    //   }
    //   this.priceMatchMark = true;
    //   this.handlePayTypeChange();
    // },
    // handlePayTypeChange(i) {
    //   if (typeof i === "number") {
    //     if (this.payType[i].total < 0) {
    //       this.payType[i].total = 0;
    //     } else {
    //       this.payType[i].total = Number(
    //         Number(this.payType[i].total).toFixed(2)
    //       );
    //     }
    //   }
    //   let res = 0;
    //   this.payType.map((item) => {
    //     if (item.checked) {
    //       res = res + solveLargeNumber(item.total);
    //     }
    //   });
    //   this.priceMatchMark = true;
    //   this.realReceive = res;
    // },
    checkPackageType() {
      // 如果是时间课包转出，弹出提示
      if (this.outputDetailData.package_type === 2) {
        this.$confirm(
          "时间课包一旦转为普通课包，将视为放弃原有权益，你确定操作？",
          "提示",
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
          }
        ).then(() => {
          this.showConfirmDialog();
        });
      } else {
        this.showConfirmDialog();
      }
    },
    showConfirmDialog() {
      // 业务人员验证
      if (this.staffCheckedData.length === 0) {
        this.showBusinessPerson = true;
        return;
      } else {
        this.showBusinessPerson = false;
      }
      this.$refs["staffForm"].validate((valid) => {
        if (valid) {
          // 检查转入学员
          if (
            JSON.stringify(this.transferInStudentInfo) == "{}" ||
            (this.transferInStudentInfo &&
              this.transferInStudentInfo.transferType === 1)
          ) {
            this.transferInMe = false;
          } else if (
            this.transferInStudentInfo &&
            this.transferInStudentInfo.transferType === 2 &&
            this.transferInStudentInfo.student_info.length === 0
          ) {
            this.$message({
              type: "warning",
              message: "请选择转入学员",
            });
            return false;
          } else {
            this.transferInMe = true;
          }
          // 检查退课
          if (Number(this.outputDetailData.refundNumber) === 0) {
            this.$message({
              type: "warning",
              message: "转课课时不能为0",
            });
            return false;
          }
          // 检查转入课
          const courseConfirm = this.inputCourseData.courseList.filter(
            (item) => {
              return (
                item.option_id && item.input_quantity && Number(item.total) >= 0
              );
            }
          );
          if (
            courseConfirm.length !== this.inputCourseData.courseList.length ||
            !courseConfirm.length
          ) {
            this.$message({
              type: "warning",
              message: "请选择转入课程",
            });
            return false;
          }

          if (this.orderResult <= 0) {
            if (!this.payTypeRadio) {
              this.$message({
                type: "warning",
                message: "请选择付款方式",
              });
              return false;
            }
            if (!this.selectTypeRadio) {
              this.$message({
                type: "warning",
                message: "请选择付款方式",
              });
              return false;
            }
          }
          this.confirmDialogVisible = true;
        }
      });
    },
    hideConfirmDialog() {
      this.confirmDialogVisible = false;
      // this.payTypeRadio = 0; // 重置
      this.selectTypeRadio = 0; // 重置
    },
    confirmSubmit() {
      const params = {
        student_id: Number(this.$route.query.sid),
        transfer_item: {
          refund_quantity: String(this.outputDetailData.refundNumber),
          should_refund_amount: String(this.outputDetailData.shouldRefund),
          handling_fee: String(this.outputDetailData.handlingFee),
          item_id: this.outputDetailData.item_id,
        },
        buy_course: this.inputCourseData.courseList.map((item) => {
          return {
            course_id: item.course_id,
            option_id: item.option_id,
            quantity: String(item.input_quantity),
            discount_type: item.discount_type,
            discount: item.discount_number ? String(item.discount_number) : "0",
            give_quantity: "0",
            effective_time: item.effective_time || "",
          };
        }),
        remark: this.staffForm.content,
        handle_time: this.handle_time,
        transfer_join_student_id: this.transfer_join_student_id,
      };
      if (this.staffCheckedData.length > 0) {
        const staff = [];
        this.staffCheckedData.map((item) => {
          staff.push(item.staff_id);
        });
        params.order_belong = staff;
      }
      // 收入
      if (this.orderResult <= 0) {
        // 注释：v2.56.x ，如果是乐沃收银，支付方式默认传 7，
        params.payment_methods = [
          {
            payment_method_id:
              Number(this.payTypeRadio) === 999 ? 7 : Number(this.payTypeRadio),
            amount: String(Math.abs(this.orderResult / 100)),
          },
        ]; // 支付方式
      } else {
        // 支出
        params.payment_methods = [
          {
            payment_method_id: 6,
            amount: String(Math.abs(this.orderResult / 100)),
          },
        ];
      }
      // 支出类型且不支持原路退回
      if (this.orderResult > 0 && !this.refundOriginalSupport) {
        params.refund_transfer = this.cardForm;
      }
      console.log(params);
      lessonTransferApi(params).then((res) => {
        if (res.error_code === 0) {
          // 开通线上支付
          if (this.online_pay) {
            // 收入（7、10），走支付流程；支出（6），走退款流程
            if (params.payment_methods[0].payment_method_id === 7) {
              // 如果为 0 元，不需要弹扫码窗
              if (params.payment_methods[0].amount === "0") {
                if (res.data.approval_id === 0) {
                  this.$message({
                    type: "success",
                    message: "转课成功",
                  });
                  setTimeout(() => {
                    this.$router.replace({
                      name: "orderManageDetail",
                      query: {
                        id: String(res.data.order_id),
                      },
                    });
                  }, 500);
                } else {
                  this.$message({
                    type: "success",
                    message: "转课成功",
                  });
                  // 提示审核
                  this.orderId = res.data.order_id;
                  this.approveDialogVisible = true;
                }
                return;
              }
              // 客户扫码付款
              getHuifuPaymentUrlApi({
                order_id: res.data.order_id,
                payer_amount: params.payment_methods[0].amount,
              }).then((urlRes) => {
                let courseFlat = [];
                this.inputCourseData.courseList.map((item) => {
                  item.sum = item.total / 100;
                  item.product_name = item.title;
                  item.payment_type = 1; // 区别收入还是支出
                  courseFlat.push(item);
                });
                this.payCodeDialogData = {
                  order_no: urlRes.data.order_no,
                  order_payment_id: urlRes.data.order_payment_id,
                  item: courseFlat,
                  order_id: res.data.order_id,
                  amount: params.payment_methods[0].amount,
                  efficient_time: urlRes.data.efficient_time,
                  counter_url:
                    process.env.VUE_APP_H5_HOST +
                    "/order-pay.html?a=" +
                    urlRes.data.order_no +
                    "&b=" +
                    urlRes.data.order_payment_id,
                  create_time: res.data.create_time,
                  student_name: this.studentData.name,
                  student_mobile: this.studentData.mobile,
                  order_type: 3, // 转课类型
                  payType: this.payType,
                };
                this.paymentDialogVisible = true;
                // v2.56.x 关闭收款确认窗，展示扫码窗
                this.confirmDialogVisible = false;
                this.mergeScanTypeDialogVisible = true;
              });
            } else if (params.payment_methods[0].payment_method_id === 3) {
              // 现金支付
              this.$message({
                type: "success",
                message: "转课成功",
              });
              this.hideConfirmDialog();
              if (res.data.approval_id > 0) {
                // 提示审核
                this.orderId = res.data.order_id;
                this.approveDialogVisible = true;
              } else {
                this.$router.replace({
                  name: "orderManageDetail",
                  query: {
                    id: String(res.data.order_id),
                  },
                });
              }
            } else if (
              params.payment_methods[0].payment_method_id === 6 ||
              params.payment_methods[0].payment_method_id === 5
            ) {
              this.$message({
                type: "success",
                message: "转课成功",
              });
              this.hideConfirmDialog();
              if (res.data.approval_id > 0) {
                // 提示审核
                this.orderId = res.data.order_id;
                this.approveDialogVisible = true;
              } else {
                this.$router.replace({
                  name: "orderManageDetail",
                  query: {
                    id: String(res.data.order_id),
                  },
                });
              }
            }
          }
          // 未开通线上支付
          if (!this.online_pay) {
            this.$message({
              type: "success",
              message: "转课成功",
            });
            // 提示审核
            this.orderId = res.data.order_id;
            this.approveDialogVisible = true;
          }
        }
      });
    },
    paymentCodeDialogChange(v) {
      this.paymentDialogVisible = v;
      this.confirmDialogVisible = v;
      // 异步跳转，避免 this.paymentDialogVisible 没被赋值
      setTimeout(() => {
        this.$router.replace({
          name: "orderManageDetail",
          query: {
            id: String(this.payCodeDialogData.order_id),
          },
        });
      }, 100);
    },
    // 现金或多种支付不支持，非现金方式支付支持原路退回
    handleOutPutChange(e) {
      // 是否支持原路退回
      this.refundOriginalSupport = e.refund_original_support;
    },
    handleOpenOnlinePay() {
      this.openOnlinePayDialog = true;
    },
    handleMergeScanTypeChange() {
      this.mergeScanTypeDialogVisible = false;
    },
    handleBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
}
.header-info {
  position: relative;
  .user {
    font-size: 16px;
    color: #5c5d5e;
    margin-left: 24px;
    .border {
      padding-right: 10px;
      margin-right: 10px;
      font-weight: bold;
      border-right: 1px solid #e7e8ea;
    }
    .mobile {
      font-weight: 400;
    }
  }
}
.block {
  border: 1px solid #d9dadb;
  border-radius: 4px;
  padding: 26px;
  margin-bottom: 26px;
  color: #5c5d5e;
  font-size: 12px;
  .title {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 21px;
    font-weight: bold;
  }
}
.tips {
  font-size: 12px;
  line-height: 14px;
  color: #ffb940;
}
.sum-total-wrap {
  font-size: 18px;
  color: #5c5d5e;
  text-align: right;
  .price {
    font-weight: bold;
    display: inline-block;
    margin-left: 36px;
    font-size: 18px;
    line-height: 24px;
    span {
      line-height: 22px;
      font-size: 22px;
    }
  }
  .select-type {
    padding: 0 5px 0 72px;
    float: left;
    .el-radio {
      margin-right: 20px;
      margin-left: 0;
      width: 162px;
      height: 30px !important;
      display: flex;
      padding: 8px 15px 0 10px !important;
      .price-icon {
        margin-left: 15px;
      }
    }
    /deep/.stage {
      padding: 0px 10px;
      .el-input {
        width: 43px;
        .el-input__inner {
          height: 28px !important;
          line-height: 28px !important;
          padding: 0;
          border: none;
        }
      }
      .unpay {
        margin-left: 20px;
        color: rgba(92, 93, 94, 1);
      }
    }
    .nowPay-price {
      float: right;
      align-items: center;
      margin-left: 36px;
      font-size: 18px;
      color: #5c5d5e;
    }
  }
}
.pay-form-wrap {
  line-height: 28px;
  font-size: 12px;
  &.error {
    .box {
      &.active {
        border: 1px solid #f56c6c !important;
      }
    }
  }
  .total {
    padding-bottom: 14px;
    border-bottom: 1px solid #d9dadb;
    margin-bottom: 32px;
    display: flex;
    align-items: center;
    .text {
      font-size: 12px;
      color: #5c5d5e;
      margin-right: 72px;
      padding-left: 5px;
      font-weight: bold;
      .tag {
        display: inline-block;
        text-align: center;
        border-radius: 2px;
        line-height: 16px;
        height: 16px;
        width: 16px;
        font-size: 12px;
        color: #ffffff;
        margin-left: 4px;
        &.red {
          background: #f56c6c;
        }
        &.green {
          background: #07d1aa;
        }
      }
    }
  }
  .form {
    font-size: 12px;
    color: #5c5d5e;
    align-items: flex-start;
    .label {
      margin: 0 5px;
    }
    .box {
      display: inline-block;
      margin-right: 38px;
      margin-bottom: 12px;
      border: 1px solid #e7e8ea;
      border-radius: 4px;
      padding: 0 8px;
      &.active {
        border-color: #07d1aa;
      }
      .text {
        margin: 0 8px;
      }
      .input {
        font-size: 12px;
        color: #5c5d5e;
        border: 0;
        width: 80px;
        text-align: right;
      }
    }
    .cashier-wrap {
      margin-right: 22px !important;
      .el-radio {
        width: 162px;
        height: 30px !important;
      }
      /deep/.disable-radio {
        padding: 6px 7px 0 10px !important;
        .is-disabled {
          .el-radio__inner {
            background: none;
            border: 1px solid rgba(231, 232, 234, 1);
            &::after {
              width: 0;
              height: 0;
            }
          }
        }
        .el-radio__label {
          color: rgba(194, 195, 196, 1) !important;
        }
        .open {
          color: white;
          background: #07d1aa;
          padding: 5px 9px;
          border-radius: 3px;
          font-size: 10px;
          cursor: pointer;
        }
      }
    }
    /deep/ .el-radio-group {
      .el-radio {
        width: 162px;
        margin: 0 22px 20px 0 !important;
      }
    }
  }
}
.foot-btn-wrap {
  text-align: left;
  margin-bottom: 12px;
  .mwow-button-filled {
    margin-right: 10px;
  }
}
.confirm-dialog {
  .info-wrap {
    .head {
      font-size: 14px;
      color: #5c5d5e;
      margin: 0 0 20px 20px;
      .name {
        font-weight: bold;
        padding-right: 12px;
        margin-right: 12px;
        border-right: 1px solid #e7e8ea;
      }
    }
    .table {
      font-size: 12px;
      color: #5c5d5e;
      line-height: 28px;
      .th,
      .tr {
        padding-left: 28px;
      }
      .th.row-7,
      .tr.row-7 {
        display: flex;
        .td {
          flex: 1;
        }
      }
      .th.row-5,
      .tr.row-5 {
        display: flex;
        .td {
          flex: 1;
        }
      }
      .th {
        background-color: #f2f6fa;
        margin-bottom: 10px;
        .td {
          font-weight: bold;
        }
      }
      .tr {
        border-bottom: 1px solid #e1e5e9;
        &:last-child {
          border-bottom: 0;
        }
        .td {
        }
      }
      .item {
        margin-bottom: 10px;
        border: 1px solid #e1e5e9;
        .title {
          padding-left: 28px;
          font-weight: bold;
          background: #f2f6fa;
          text-align: left;
        }
      }
    }
    .sum-wrap {
      text-align: right;
      margin: 16px 0;
      font-size: 16px;
      line-height: 22px;
      font-weight: bold;
      .red {
        color: #f56c6c;
      }
    }
    .input-title {
      padding: 16px 25px;
      border-top: 1px solid #e7e8ea;
      margin: 0 -20px;
      font-size: 14px;
      color: #5c5d5e;
      font-weight: bold;
    }
  }
  .transfer-out {
    padding: 0 25px 16px 25px;
    margin: 0 -20px;
    font-size: 14px;
    color: #5c5d5e;
    font-weight: bold;
  }
  .pay-info {
    border-top: 1px solid #e7e8ea;
    margin: 0 -20px;
    padding: 16px 20px 4px 20px;
    p {
      line-height: 14px;
      font-size: 12px;
      margin-bottom: 16px;
      color: #5c5d5e;
      .tag {
        border-right: 1px solid #e7e8ea;
        padding-right: 8px;
        margin-right: 8px;
        &:last-child {
          border-right: 0;
        }
      }
      .red {
        color: #f56c6c;
      }
      .type-tag {
        font-size: 12px;
        width: 16px;
        height: 16px;
        border-radius: 4px;
        line-height: 16px;
        text-align: center;
        color: #fff;
        display: inline-block;
        margin-left: 6px;
        &.red {
          background: #f56c6c;
        }
        &.green {
          background: #07d1aa;
        }
      }
    }
  }
  .warning-info {
    line-height: 40px;
    background-color: #fff7e9;
    font-size: 12px;
    color: #ffb940;
    text-align: center;
    margin: 0 -20px 21px -20px;
    i {
      margin-right: 8px;
      font-size: 16px;
      vertical-align: middle;
    }
  }
  .bottom-btns {
    text-align: right;
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
.big-box {
  display: flex;
  align-items: flex-start;
  .item {
    display: inline-flex;
    line-height: 28px;
    margin-bottom: 12px;
    margin-left: 100px;
    font-size: 12px;
    color: #5c5d5e;
    .label {
      min-width: 70px;
    }
    .content {
      flex: 1;
      .red {
        color: #f56c6c;
      }
      &.error {
        .box {
          &.active {
            border: 1px solid #f56c6c !important;
          }
        }
      }
      .box {
        display: inline-block;
        margin-right: 38px;
        border: 1px solid #e7e8ea;
        border-radius: 4px;
        padding: 0 8px;
        &.active {
          border-color: #07d1aa;
        }
        .text {
          margin: 0 8px;
        }
        .input {
          font-size: 12px;
          color: #5c5d5e;
          width: 60px;
          border: 0;
        }
      }
    }
    .belong-wrap {
      .tag {
        display: inline-block;
        vertical-align: middle;
        background-color: #f6fafc;
        padding: 0 12px;
        border-radius: 4px;
        margin-right: 12px;
        white-space: nowrap;
        margin-bottom: 10px;
      }
      .btn {
        color: #07d1aa;
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }
}
.dialog {
  .content {
    font-size: 14px;
    line-height: 20px;
  }
  .btns {
    padding-top: 10px;
    justify-content: flex-end;
    .cat-btn {
      font-size: 12px;
      background: #07d1aa;
      color: white;
      padding: 0 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
